import Vue from "vue";
const state = () => ({
  parametres: {},
});

const mutations = {
  SET_PARAMETRES(state, payload) {
    console.log("SET_PARAMETRES");
    state.parametres = payload;
  },
  SET_PARAMETRES_ALWAYS_ON(state, payload) {
    console.log("SET_PARAMETRES_ALWAYS_ON", payload);
    //state.parametres = payload;
  },
};

const actions = {
  async realitimeListenerParametres({ commit, dispatch, rootState }) {
    try {
      commit("Loading/START_BUSY_STATE", "realitimeListenerParametres", {
        root: true,
      });
      await this._vm.$firebase
        .firestore()
        .collection("options")
        .doc("VB08AelKInuKBr3fG6fM")
        .onSnapshot(function (doc) {
          // var source = doc.metadata.hasPendingWrites ? "Local" : "Server";
          commit("SET_PARAMETRES", doc.data());
          //commit("SET_PARAMETRES_ALWAYS_ON", rootState.Auth.user);
          
          commit("Loading/END_BUSY_STATE", "realitimeListenerParametres", {
            root: true,
          });
        });
    } catch (err) {
      console.log("Error getting documents", err);
    }
  },
};

const getters = {
  parametres: (state) => {
    return state.parametres;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
